module.exports = __webpack_public_path__ + "img/202210.bf377d84.png";